import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'automationOnHold/list';

export function useAutomationsOnHoldQuery({
	includeAll,
	enabled = true,
	impersonationContext,
}: {
	includeAll?: boolean;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();

	const queryParams: Record<string, boolean> = {};
	if (includeAll !== undefined) {
		queryParams.includeAll = includeAll;
	}

	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationOnHold[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'automationOnHold',
					queryParams: Object.keys(queryParams).length > 0 ? queryParams : undefined,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, includeAll, impersonationContext?.account?.id],
	});
}

export function invalidateAllAutomationsOnHoldQueries() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
